/*
    Implements the template object
     - stores templates
     - returns rendered content using Mustache template renderer
 */

import Mustache from 'mustache';
import {defaultContext} from "@/context/global.js";

export const UITemplates = {
    ready: false,
    elog: function () {
        //logging facility
        return (typeof elog === "function") ? elog : function (severity, message) {
            if (typeof console[severity.toLowerCase()] === "function") {
                console[severity.toLowerCase()](message);
            }
        };
    }(),

    templates: function () {
        let r = new Map()
        var xhr = new XMLHttpRequest();
        xhr.open(
            'GET',
            'templates.html' + (defaultContext.templateVersion ? '?v=' + defaultContext.templateVersion : ''),
            true);
        xhr.onload = function() {
            var div = document.createElement('div');
            div.innerHTML = xhr.responseText;
            div.querySelectorAll('script').forEach(function(c) {
                r.set(c.getAttribute("contentID"), c.innerHTML);
            });
            UITemplates.ready = true;
        };
        xhr.onerror = function() {
            console.error('Failed to load templates');
        };
        xhr.send();
        return r;
    }(),

    // renders content using Mustache, options contains variables, partials is optional and
    // can contain partial entities (includes etc)
    getContent: function(id, options, partials) {
        let c = this.templates.get(id)
        if (!c) {
            if (! this.ready) {
                this.elog("ERROR", "content is still not loaded")
            } else {
                this.elog("ERROR", "unknown content with id '" + id + "'")
            }
            return "";
        }
        if (! options)
            return c;

        return Mustache.render(c, options, partials);
    },

    getContentAsync: function (id) {
        return new Promise(function(resolve, reject) {
            let timeout = null;

            function checkContent() {
                let c = this.templates.get(id)
                if (c) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    resolve(c);
                } else {
                    if (!timeout) {
                        timeout = setTimeout(function () {
                            reject(new Error('Timeout exceeded'));
                        }, 5000)
                    }
                    setTimeout(checkContent, 50);
                }
            }
            checkContent();
        });
    }
}
